import {DayType} from "../../../model/common.model";
import {ApprovalState} from "./ApprovalState";
import {DisplayInterval} from "../../../directives/displayInterval";
import * as moment from 'moment';
import {Utils} from "../../../model/Utils";

export class EmployeeAvailabilitySpecial {
  id: number;
  employeeCode: string;
  dayType: DayType;
  date: Date;
  // interval: number;
  note: string;
  available: boolean;
  intervalForHuman: string;
  startHour: Date;
  endHour: Date;
  noteFromApprover: string;

  // startTime: string;
  // endTime: string;
  state: ApprovalState;

  memoId: number; //memoId will populated when trying to accept or reject a request of new availability from the employee.


  prepareIntervalForHuman(di: DisplayInterval){
//    this.intervalForHuman = di.transform(this.interval);
    this.intervalForHuman = di.displayDates(this.startHour,this.endHour,di.formatAMPM,true);
  }

  _createSpecialElement(propertyName: string, data: any) {
    if ('dayType' === propertyName) {
      this.dayType = DayType.retrieveFromCode(data);
      return true;
    }
    if ('state' === propertyName) {
      this.state = ApprovalState.retrieveFromCode(data);
      return true;
    }
    return false;
  }

  isToday(){
    return Utils.sameDay(moment().toDate(),this.date);
  }

  isInThePast(){
    return Utils.isBeforeToday(this.date);
  }


  static sort(lst: EmployeeAvailabilitySpecial[]): EmployeeAvailabilitySpecial[]{
    lst.sort((e1: EmployeeAvailabilitySpecial, e2: EmployeeAvailabilitySpecial)  => {
      let resN = 0;
      const l1 = moment(e1.date)
      const l2 = moment(e2.date);

      if (l1 < l2){
        resN = 1;
      }else{
        resN = -1;
      }
      if (l1 === l2){
        resN = 0;
        if (Utils.isBeforeRefDate(e1.startHour,e2.startHour)){
          resN = 1;
        }else{
          resN = -1;
        }
      }
      return resN;
    });
    return lst;
  }


}
